<template>
  <page-template>

    <board :is-fold="isFold"
           :http-options="httpOptions"
           :config="config"
           :insert-row-function="() => insertRow('createEmptySupplier')"
           :disabled-delete-button="true"
           :disabled-play-button="true"/>

  </page-template>
</template>

<script>
import Vue from 'vue';

import config from './Config';
import Editor from './detail-row/SupplierEditor';
import CommonBoardItems from '../CommonBoardItems';

Vue.component(config.detailRowComponentName, Editor);

export default {
  name: 'BoardSupplierManagement',
  mixins: [CommonBoardItems],
  data() {
    return {
      config,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/spa/components/board/supplier-management/BoardSupplierManagement.vue